// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aDeW6","importantInfo":"styles_importantInfo__LOeAx"};